module.exports = __webpack_public_path__ + "static/Waiting-Room_mobile-4e9330a35b7bcd736ce1016fa1815ec6.webp";